import React, { useEffect, useRef, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { FileButton, FileItem, OccItem } from "./styled";
import { toast } from "react-toastify";
import api from "../../api/axios";
import dayjs from "dayjs";

export const CreateNewOcurrencesModal = ({ open, onClose, professional }) => {
  const fileInputRef = useRef();

  const [occurrences, setOccurrences] = useState([]);
  const [oportunities, setOportunities] = useState([]);
  const [files, setFiles] = useState([]);

  const [values, setValues] = useState({
    title: "",
    description: "",
    oportunity: null,
    professional: "",
  });

  const [newFile, setNewFile] = useState({
    occurrence: "",
    name: "",
    addedIn: null,
  });
  const [file, setFile] = useState(null);

  const [expandedOccurrence, setExpandedOccurrence] = useState(null);

  const [error, setError] = useState("");

  const [isAdding, setIsAdding] = useState(false);
  const [isAddingFile, setIsAddingFile] = useState(false);
  const [isAddingFileAdd, setIsAddingFileAdd] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getData = async () => {
    try {
      const { data } = await api.get(
        `/professional_occurrence/get-by-professional/${professional._id}`,
      );
      console.log(data);
      setOccurrences(data);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    }
  };

  const getOportunities = async () => {
    try {
      const { data } = await api.get(
        `/application/get-by-professional/${professional._id}`,
      );
      setOportunities(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const getFiles = async (occ) => {
    try {
      const { data } = await api.get(
        `/occurrence_file/get-by-occurrence/${occ}`,
      );
      setFiles(data);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);
  };

  const handleFileClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    if (!values.title || !values.description) {
      setError("Todos os campos devem ser preenchidos");
      setIsSubmitting(false);
      return;
    }

    try {
      await api.post("/professional_occurrence/create", values);
      toast.success("Ocorrência adicionada");

      setIsAdding(false);
      resetValues();
      getData();
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmitFile = async (occurrence) => {
    setIsSubmitting(true);

    if (!file) {
      toast.error("É preciso anexar um arquivo");
      setIsSubmitting(false);
      return;
    }

    const isFormValid = Object.values(newFile).every((v) => v !== "");

    if (!isFormValid) {
      toast.error("Por favor, preencha todos os campos!");
      setIsSubmitting(false);
      return;
    }

    if (!newFile.addedIn) newFile.addedIn = new Date();

    try {
      const formData = new FormData();

      formData.append("values", JSON.stringify({ ...newFile }));
      formData.append("file", file);

      await api.post("/occurrence_file/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      getFiles(occurrence._id);
      resetValues();
      setIsAddingFile(false);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmitFileWithOcc = async () => {
    setIsSubmitting(true);

    if (!values.title || !values.description) {
      setError("Todos os campos devem ser preenchidos");
      setIsSubmitting(false);
      return;
    }

    if (!file) {
      toast.error("É preciso anexar um arquivo");
      setIsSubmitting(false);
      return;
    }

    if (!newFile.name) {
      toast.error("Por favor, preencha todos os campos!");
      setIsSubmitting(false);
      return;
    }

    if (!newFile.addedIn) newFile.addedIn = new Date();

    try {
      const { data } = await api.post(
        "/professional_occurrence/create",
        values,
      );
      toast.success("Ocorrência adicionada");

      if (!newFile.occurrence) newFile.occurrence = data._id;

      const formData = new FormData();

      formData.append("values", JSON.stringify({ ...newFile }));
      formData.append("file", file);

      await api.post("/occurrence_file/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      getFiles(data._id);
      setIsAdding(false);
      setIsAddingFileAdd(false);
      resetValues();
      getData();
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (occ) => {
    try {
      await api.delete(`/professional_occurrence/delete/${occ._id}`);
      toast.success("Ocorrência excluída");

      getData();
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleDeleteFile = async (id, occ) => {
    try {
      setIsSubmitting(true);

      await api.delete("/occurrence_file/delete/" + id);
      getFiles(occ._id);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAdd = () => {
    resetValues();
    setIsAddingFile(false);
    setIsAdding(true);
  };

  const handleAddFile = (occ) => {
    resetValues();
    setNewFile({ ...newFile, occurrence: occ._id });
    setIsAddingFile(true);
    setIsAdding(false);
  };

  const handleAddFileAdd = () => {
    setIsAddingFileAdd(true);
  };

  const handleCancel = () => {
    setError("");
    resetValues();
    setIsAddingFile(false);
    setIsAddingFileAdd(false);
    setIsAdding(false);
  };

  const handleExpand = (occId) => {
    setExpandedOccurrence((prev) => (prev === occId ? null : occId));
  };

  const resetValues = () => {
    setValues({
      title: "",
      description: "",
      oportunity: null,
      professional: professional._id,
    });
    setNewFile({
      occurrence: "",
      name: "",
      addedIn: null,
    });
    setFile(null);
  };

  const handleClose = () => {
    setError("");
    setOccurrences([]);
    setFiles([]);
    setIsAdding(false);
    setIsAddingFile(false);
    setIsAddingFileAdd(false);
    resetValues();
    onClose();
  };

  useEffect(() => {
    if (open && professional) {
      getOportunities();
      getData();
      setValues({
        ...values,
        professional: professional._id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [professional, open]);

  useEffect(() => {
    console.log("GETTING FILES");
    setFiles([]);

    if (expandedOccurrence) getFiles(expandedOccurrence);
  }, [expandedOccurrence]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "700px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">{"Ocorrências"}</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            padding: "10px 20px",
            minWidth: "300px",
            width: "100%",
            gap: "1.5rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {occurrences && occurrences.length > 0 ? (
              occurrences.map((occ, index) => {
                const occurrenceId = occ._id || `occ${index}`;
                const isExpanded = expandedOccurrence === occurrenceId;

                return (
                  <OccItem key={occurrenceId}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "#104467",
                          fontWeight: "bold",
                        }}
                      >
                        {`${occ.title} (${dayjs(occ.date).format("DD/MM/YYYY")})`}
                      </span>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <Tooltip
                          arrow
                          placement="bottom"
                          title={isExpanded ? "Recolher" : "Expandir"}
                        >
                          <IconButton
                            onClick={() => handleExpand(occurrenceId)}
                          >
                            {isExpanded ? (
                              <ExpandLessIcon
                                style={{
                                  fontSize: "20px",
                                  padding: 0,
                                }}
                              />
                            ) : (
                              <ExpandMoreIcon
                                style={{
                                  fontSize: "20px",
                                  padding: 0,
                                }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>

                        <Tooltip
                          arrow
                          placement="bottom"
                          title="Excluir Ocorrência"
                        >
                          <IconButton onClick={() => handleDelete(occ)}>
                            <CloseIcon
                              style={{
                                fontSize: "20px",
                                padding: 0,
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>

                    <span>{occ.description}</span>

                    {isExpanded && (
                      <div
                        style={{
                          marginTop: "15px",
                          padding: "15px",
                          borderTop: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {files.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            {files.map((file) => (
                              <div
                                key={file._id}
                                style={{ display: "flex", gap: "5px" }}
                              >
                                <FileItem
                                  onClick={() =>
                                    window.open(file.url, "_blank")
                                  }
                                >
                                  <span>{file.name}</span>
                                  <span
                                    style={{
                                      color: "#777",
                                      fontSize: "0.75rem",
                                    }}
                                  >{`Adicionado em: ${dayjs(file.addedIn).format("DD/MM/YYYY")}`}</span>
                                </FileItem>
                                <div style={{ margin: "auto 0" }}>
                                  <Tooltip
                                    arrow
                                    placement="right"
                                    title="Remover"
                                  >
                                    <IconButton
                                      disabled={isSubmitting}
                                      onClick={() =>
                                        handleDeleteFile(file._id, occ)
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          !isAddingFile && (
                            <span
                              style={{
                                color: "#104467",
                                fontWeight: "bold",
                                alignSelf: "center",
                              }}
                            >
                              {"Essa ocorrência não possui nenhum anexo"}
                            </span>
                          )
                        )}
                        {!isAddingFile && (
                          <Button
                            sx={{
                              width: "100%",
                              margin: "20px 0",
                              color: "#104467",
                            }}
                            onClick={() => handleAddFile(occ)}
                          >
                            + Adicionar anexo
                          </Button>
                        )}

                        {isAddingFile && (
                          <>
                            <hr />
                            <TextField
                              label="Nome do arquivo"
                              id="name"
                              name="name"
                              type="text"
                              value={newFile.name}
                              onChange={(e) => {
                                setNewFile({
                                  ...newFile,
                                  name: e.target.value,
                                });
                              }}
                            />
                            <FileButton
                              onClick={handleFileClick}
                              disabled={isSubmitting}
                            >
                              {"Adicionar Arquivo"}
                            </FileButton>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx"
                              ref={fileInputRef}
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                            />
                            <span
                              style={{
                                color: "#104467",
                                fontSize: "0.8rem",
                                margin: "0 auto",
                              }}
                            >
                              {file ? `Arquivo adicionado: ${file.name}` : ""}
                            </span>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "15px",
                              }}
                            >
                              <Button
                                sx={{ color: "#104467" }}
                                onClick={handleCancel}
                                disabled={isSubmitting}
                              >
                                Cancelar
                              </Button>
                              <Button
                                sx={{
                                  backgroundColor: "#104467",
                                  color: "white",
                                }}
                                onClick={() => handleSubmitFile(occ)}
                                variant="contained"
                                disabled={isSubmitting}
                              >
                                {"Salvar"}
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </OccItem>
                );
              })
            ) : (
              <span style={{ alignSelf: "center" }}>
                Ainda não existem ocorrências para esse profissional
              </span>
            )}
          </div>
          {!isAdding && (
            <Button
              sx={{ width: "100%", margin: "20px 0", color: "#104467" }}
              onClick={handleAdd}
            >
              + Adicionar
            </Button>
          )}
          {isAdding && (
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
                margin: "20px 0",
              }}
            >
              <hr />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label for="oportunity" style={{ marginBottom: "10px" }}>
                  Oportunidade:
                </label>
                <Select
                  id="oportunity"
                  name="oportunity"
                  label="Oportunidade"
                  disabled={oportunities.length < 1}
                  value={values.oportunity}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      oportunity: e.target.value,
                    })
                  }
                >
                  <MenuItem value={null}>Nenhuma</MenuItem>
                  {oportunities.map((item) => (
                    <MenuItem
                      value={item._id}
                    >{`${item?.oportunity?.cargo} (${item?.oportunity?.empresa})`}</MenuItem>
                  ))}
                </Select>
              </div>
              <TextField
                label="Título"
                id="title"
                name="title"
                type="text"
                value={values.title}
                onChange={(e) => {
                  setValues({ ...values, title: e.target.value });
                  setError("");
                }}
              />
              <TextField
                label="Descrição"
                id="description"
                name="description"
                type="text"
                value={values.description}
                onChange={(e) => {
                  setValues({ ...values, description: e.target.value });
                  setError("");
                }}
                multiline
                minRows={4}
                maxRows={10}
              />
              {!isAddingFileAdd && (
                <Button
                  sx={{
                    width: "100%",
                    margin: "20px 0",
                    color: "#104467",
                  }}
                  onClick={handleAddFileAdd}
                >
                  + Adicionar anexo
                </Button>
              )}
              {isAddingFileAdd && (
                <>
                  <hr />
                  <TextField
                    label="Nome do arquivo"
                    id="name"
                    name="name"
                    type="text"
                    value={newFile.name}
                    onChange={(e) => {
                      setNewFile({
                        ...newFile,
                        name: e.target.value,
                      });
                    }}
                  />
                  <FileButton onClick={handleFileClick} disabled={isSubmitting}>
                    {"Adicionar Arquivo"}
                  </FileButton>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      color: "#104467",
                      fontSize: "0.8rem",
                      margin: "0 auto",
                    }}
                  >
                    {file ? `Arquivo adicionado: ${file.name}` : ""}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      gap: "15px",
                    }}
                  >
                    <Button
                      sx={{ color: "#104467" }}
                      onClick={() => {
                        setIsAddingFileAdd(false);
                        setNewFile({
                          occurrence: "",
                          name: "",
                          addedIn: null,
                        });
                        setFile(null);
                      }}
                      disabled={isSubmitting}
                    >
                      Cancelar Anexo
                    </Button>
                  </div>
                </>
              )}

              {error && <span style={{ color: "red" }}>{error}</span>}
              <div
                style={{ display: "flex", justifyContent: "end", gap: "10px" }}
              >
                <Button
                  sx={{ color: "#104467" }}
                  onClick={handleCancel}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button
                  sx={{
                    backgroundColor: "#104467",
                    color: "white",
                  }}
                  onClick={
                    isAddingFileAdd ? handleSubmitFileWithOcc : handleSubmit
                  }
                  variant="contained"
                  disabled={isSubmitting}
                >
                  {"Salvar"}
                </Button>
              </div>
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button
          sx={{ color: "#104467" }}
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
